module.exports = __webpack_public_path__ + "img/snake_control_right.d4de3486.svg";